import React from 'react';
import '../css/about.css';
import { Link } from 'react-router-dom'

class About extends React.Component {
  render() {
    return(
      <div className="about">
        <h2>About Us</h2>
        <div className="image">
          <img src="https://cdn.hotelplanner.com/Common/Images/_HotelPlanner/Home-Page/fade/sld6.jpg" height="720" width="1080"/>
        </div>
        <div className="text">
        <p>Sarathi is a travel booking guide which helps you to book hotel rooms across different cities(just Mumbai as of now since the website is still in development) and provides you with the best deals and packages.
        Here, you will be provided with information regarding various facilities provided by the hotels and also the reviews posted on Google from other users who have already visited the hotels.</p>
        <p>You can even share your suggestions with us. Let us know about your opinion on the <Link to="/feedback">Feedback page</Link></p>
        </div>
      </div>
    );
  }
}

export default About;
